import { SidebarAssetConfiguration, SidebarEntryConfiguration } from './sidebar-defaults'
import { EntryConfiguration } from './editors-defaults'
import getDefaultControlOfField from './controls-defaults'

export default {
  SidebarEntryConfiguration,
  SidebarAssetConfiguration,
  EntryConfiguration,
  getDefaultControlOfField,
}
